import { FC } from 'react'

import { NotificationApiType } from '@/api/models/notifications/lib/notifications.types'
import { cn } from '@/app/utils'

import { NotificationCard } from '.'

type Props = {
  notifications: NotificationApiType[]
  className?: string
  onMarkAsRead: (id: string) => void
}

const NotificationList: FC<Props> = ({
  notifications,
  className,
  onMarkAsRead
}) => {
  return (
    <div
      className={cn(
        'border-12 space-y-16 border border-transparent',
        className
      )}
    >
      {notifications.map(notificationItem => (
        <NotificationCard
          key={notificationItem.id}
          item={notificationItem}
          className="cursor-pointer transition-colors hover:bg-grey-20"
          onMarkAsRead={onMarkAsRead}
        />
      ))}
    </div>
  )
}

export default NotificationList
